import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { Endorsement, VehicleExposureAndCoveragesForm, GaragingLocationForm, AdditionalInterestForm, ClassExposureForm, CoveragesForm, LocationForm, CoveragesAndLimitsForm, BuildingAndLocationForm, PropertyCoveragesAndLimitsForm, RetainedLimitsAndUnderliersForm, EntityAndLocationForm, WCClassExposureForm, Vehicle, IMPRCoverages, AdditionalNamedInsureds, AnotherClassExposure, AnotherCoveragesForm, AnotherWCClassExposure } from '../_models/endorsement';
import { NgForm } from '@angular/forms';
import { PRODUCT_CONFIG, FILE_UPLOAD_CONFIG, ENDORSEMENT_MSGS, ENDORSEMENT_CONFIG } from 'src/app/_common/product-config';
import { EndorsementService } from '../_services/endorsement.service';
import { EndorsementSteps, LOBType, EndorsementType, DocumentFileType, LocationType, ClassAction } from 'src/app/_common/_enum/module.enum';
import { US_STATES } from 'src/app/_common/us-states';
import { AdditionalInterestType, PremiumBasis, RetainedLimit } from '../_models/endorsement-constants';
import { HeaderData } from 'src/app/_models/header-data';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-endorsement-underwriting-form',
  templateUrl: './endorsement-underwriting-form.component.html',
  styleUrls: ['./endorsement-underwriting-form.component.scss']
})
export class EndorsementUnderwritingFormComponent implements  OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private selectedPolicy;
  private selectedAccount;

  private lobTypeEnum = LOBType; // Using it in HTML
  private endorsementTypeEnum = EndorsementType; // Using it in HTML
  private documentFileTypeEnum = DocumentFileType; // Using it in HTML
  private locationTypeEnum = LocationType; // Using it in HTML
  private classActionEnum = ClassAction;
  private USAStates = US_STATES;
  private endorsementUnderwritingForm: Endorsement;
  private additionalInterestTypeValues = AdditionalInterestType;
  private premiumBasisValues = PremiumBasis;
  private retainedLimitValues = RetainedLimit;
  private vehicleExposureAndCoverages: VehicleExposureAndCoveragesForm;
  private isSubmitted: boolean = false;
  private supportingDocuments = [];
  private endorsementMsgs = ENDORSEMENT_MSGS; //Using it in HTML
  private endorsementConfig = ENDORSEMENT_CONFIG; //Using it in HTML
  private productConfig = PRODUCT_CONFIG; //Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML

  private account_mailingAddress = null;
  private account_namedInsured = null;
  private account_other = null;

  private driverReviewAttachError: string = null;
  private monthlyReportAttachError: string = null;
  private acordAttachmentError: string = null;

  private modalReference;
  private removeRequestLabel : string  = "";
  private removeRequestType = null;

  private uploadedFileSize: number = 0;

  @Output() uwFormFileSize = new EventEmitter<any>();

  @ViewChild("underwritingForm", {static: false}) underwritingForm: NgForm;
  @ViewChild("removeRequestModal", {static: false}) removeRequestModal;
  constructor(private endorsementService:EndorsementService, private commonService: CommonService, private modalService : NgbModal, private el: ElementRef) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    
    this.endorsementUnderwritingForm = this.getEndorsement();
    this.selectedAccount = this.endorsementService.getAccountData();

    if(this.endorsementUnderwritingForm.EndorsementForm && Object.keys(this.endorsementUnderwritingForm.EndorsementForm).length > 0){
      this.supportingDocuments = this.endorsementService.getSupportingDocuments();//(this.endorsementUnderwritingForm.supportingDocuments)?this.endorsementUnderwritingForm.supportingDocuments:[];

      if(this.endorsementUnderwritingForm.EndorsementForm['ACCOUNT'] && this.endorsementUnderwritingForm.EndorsementForm['ACCOUNT']['NAMEDINSURED']){
        (this.endorsementUnderwritingForm.EndorsementForm['ACCOUNT']['NAMEDINSURED']).forms.forEach(namedInsuredForm => {
          namedInsuredForm.currentNamedInsured = this.selectedAccount.accountName;
        });
      }
    }else{
      this.endorsementService.endorsement = new Endorsement();
      this.endorsementService.selectedStep = EndorsementSteps.BasicInfo;
    }
    
    this.selectedPolicy = this.endorsementService.getPolicyData();

    let allDocuments = this.endorsementService.getSupportingDocuments();
    
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.uwFormFileSize.emit(this.uploadedFileSize);
    this.setHeaderData();
  }
  
  setHeaderData(){
    this.headerData.pageTitle = (this.endorsementUnderwritingForm.isQuote)?"Endorsement Quote Request": "Endorsement Request";
    if(this.selectedPolicy){
      this.headerData.pageTitle = (this.endorsementUnderwritingForm.isQuote)?"Endorsement Quote Request": "Endorsement Request";
      this.headerData.breadcrumb = [{ itemName: this.selectedPolicy.accountName, itemLink:  "/accounts/" + this.selectedPolicy.accountNumber + "/endorsements"}, {itemName:this.selectedPolicy.policyNumber, itemLink:"policies/"+ this.selectedPolicy.policyNumber+"/endorsements"}];
    }
    this.endorsementService.header = this.headerData;
  }

  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }
  
  getEndorsement(){
    return this.endorsementService.endorsement;
  }

  fileBrowseHandler(files) {
    this.uploadAllDocuments(files, this.documentFileTypeEnum.Acord);
  }

  uploadAllDocuments(files, _docFileType=this.documentFileTypeEnum.Acord){
    if(files.currentTarget && files.currentTarget.files){
      files = files.currentTarget.files;
    }

    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }

    if(_docFileType == this.documentFileTypeEnum.Acord){
      this.acordAttachmentError = null;
    }else if(_docFileType == this.documentFileTypeEnum.DriverReview){
      this.driverReviewAttachError = null;
    }else if(_docFileType == this.documentFileTypeEnum.MonthlyReporter){
      this.monthlyReportAttachError = null;
    }

    let allDocuments = this.endorsementService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });

    Array.from(files).forEach((_file:any)=>{
      _file.docFileType = _docFileType;
      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size)))<this.endorsementConfig.MaxUploadSize){
        this.uploadedFileSize+=(Number(_file.size));
        this.endorsementService.addSupportingDocument(_file);  
      }else if(_file.size == 0){
        if(_docFileType == this.documentFileTypeEnum.Acord){
          this.acordAttachmentError = this.fileUploadConfig.AttachmentNoContent;
        }else if(_docFileType == this.documentFileTypeEnum.DriverReview){
          this.driverReviewAttachError = this.fileUploadConfig.AttachmentNoContent;
        }else if(_docFileType == this.documentFileTypeEnum.MonthlyReporter){
          this.monthlyReportAttachError = this.fileUploadConfig.AttachmentNoContent;
        }
        console.log("File has no content");
      }else{
        if(_docFileType == this.documentFileTypeEnum.Acord){
          this.acordAttachmentError = this.fileUploadConfig.AttachmentExceeds;
        }else if(_docFileType == this.documentFileTypeEnum.DriverReview){
          this.driverReviewAttachError = this.fileUploadConfig.AttachmentExceeds;
        }else if(_docFileType == this.documentFileTypeEnum.MonthlyReporter){
          this.monthlyReportAttachError = this.fileUploadConfig.AttachmentExceeds;
        }
        console.log("File size exceeding");
      }
    });

    this.supportingDocuments = this.endorsementService.getSupportingDocuments();
    this.uwFormFileSize.emit(this.uploadedFileSize);
  }

  removeDocument( _docFileType, _uniqueName){
    let allDocuments = this.endorsementService.getSupportingDocuments();
    let fileIndex = allDocuments.findIndex(_docFile=>{return _docFile.uniqueName == _uniqueName});
    this.endorsementService.getSupportingDocuments().splice(fileIndex, 1);
    
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.uwFormFileSize.emit(this.uploadedFileSize);

    if(_docFileType == this.documentFileTypeEnum.Acord && this.uploadedFileSize < this.fileUploadConfig.MaxUploadSize){
      this.acordAttachmentError = null;
    }else if(_docFileType == this.documentFileTypeEnum.DriverReview){
      this.driverReviewAttachError = null;
    }else if(_docFileType == this.documentFileTypeEnum.MonthlyReporter){
      this.monthlyReportAttachError = null;
    }
  }

  getSupportingDocuments(_docFileType){
    let docFiles = this.endorsementService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == _docFileType});

    return docFiles;
  }

  anyAdditionalInsuredActionSelected(_additionalInsureds){
    return _additionalInsureds.filter(_additionalInsured=>{return _additionalInsured.action !=''}).length > 0;
  }

  makeFieldsBlank(_parent, _fields){
    _fields.forEach(_field=>{
      _parent[_field] = "";
    })
  }
  
  hasLOBTypeForm(_type){
    return this.endorsementUnderwritingForm.EndorsementForm[_type.toUpperCase()] != undefined;
  }

  hasEndorsementTypeForm(_type, _endorsementType){
    return this.endorsementUnderwritingForm.EndorsementForm[_type.toUpperCase()] != undefined && this.endorsementUnderwritingForm.EndorsementForm[_type.toUpperCase()][_endorsementType.toUpperCase()];
  }

  /* Check if defined location is already selected. Disable all other defined locations  */
  hasLocationTypeAdded(_forms, _currentForm, _isType){
    if(_forms.length > 1 && _forms.some(_primaryForm=>{return _primaryForm.type == _isType}) && _currentForm.type != _isType){
      return true;
    }
    return false;
  }
  addAnotherNamedInsured(additionalNamedInsureds){
    additionalNamedInsureds.push(new AdditionalNamedInsureds());
  }

  addAnotherClass(_classs){
    console.log(_classs);
    _classs.push(new AnotherClassExposure());
  }

  addAnotherClassExposureExposureAndCoverages(_form){
    _form.push(new ClassExposureForm());
  }
  
  removeSection(additionaInsureds, index){
    if(additionaInsureds.length > 1){
      additionaInsureds.splice(index, 1);
    }
  }

  primaryLocationSelected(_location){
    _location.streetAddress = "";
    _location.streetAddress2 = "";
    _location.city = "";
    _location.state = "";
    _location.zipCode ="";
  }

  //#region  EndorsementTypes Methods 
  /** AU */

  addAnotherVehicle(_vehicles){
    _vehicles.push(new Vehicle());
  }

  addAnotherVehicleExposureAndCoverages(_forms){
    _forms.push(new VehicleExposureAndCoveragesForm());
  }

  addAnotherGaragingLocation(_forms){
    _forms.push(new GaragingLocationForm());
  }

  addAnotherAdditionalInterest(_forms){
    _forms.push(new AdditionalInterestForm());
  }

  selectNewLocationType(_form, _arrayField){
    _form[_arrayField].forEach((_field)=>{
      if(_field.action == this.classActionEnum.DELETE)
      _field.action = '';
    })
  }
  /** AU */

  /** GL */
  addAnotherGLLocation(_forms){
    _forms.push(new LocationForm());
  }

  /** PL */
  addAnotherPLClass(_coverages){
    _coverages.push(new AnotherCoveragesForm())
  }

  addAnotherPLCoverages(_forms){
    _forms.push(new CoveragesForm());
  }

  addAnotherPLLocation(_forms){
    _forms.push(new LocationForm());
  }
  /** PL */
  
  /** CR */
  addAnotherCRClass(_coverages){
    _coverages.push(new AnotherCoveragesForm())
  }

  addAnotherCRCoverages(_forms){
    _forms.push(new CoveragesForm());
  }

  addAnotherCRLocation(_forms){    
    _forms.push(new LocationForm());
  }
  /** CR */
  
  /** BOP */
  addAnotherBOPCoverageClass(_coverages){
    _coverages.push(new AnotherCoveragesForm())
  }

  addAnotherBOPCoverages(_forms){
    _forms.push(new CoveragesForm());
  }

  //addAnotherBuildingAndLocation
  /** BOP */

  /** IM */
  addAnotherIMCoverageClass(_coverages){
    _coverages.push(new IMPRCoverages());
  }

  addAnotherIMCoverages(_forms){
    _forms.push(new CoveragesAndLimitsForm());
  }

  //addAnotherBuildingAndLocation
  /** IM */

  /** PR */
  addAnotherPRCoverageClass(_coverages){
    _coverages.push(new IMPRCoverages());
  }

  addAnotherPRCoverages(_forms){
    _forms.push(new PropertyCoveragesAndLimitsForm());
  }

  //addAnotherBuildingAndLocation
  /** IM */

  addAnotherBuildingAndLocation(_forms){
    _forms.push(new BuildingAndLocationForm());
  }

  /** UM, EX */
  addAnotherRetainedLimitsAndUnderliers(_forms){
    _forms.push(new RetainedLimitsAndUnderliersForm());
  }
  /** UM, EX */

  /** WC */
  addAnotherWCClass(_class){
    _class.push(new AnotherWCClassExposure());
  }
  addAnotherWCClassExposureForm(_forms){
    _forms.push(new WCClassExposureForm());
  }

  addAnotherWCLocation(_forms){
    _forms.push(new EntityAndLocationForm());
  }
  /** WC */
//#endregion EndorsementTypes Methods

  removeRequest(_type){
    if(_type){
      delete this.endorsementUnderwritingForm.EndorsementForm[_type.toUpperCase()];
      this.endorsementUnderwritingForm[_type].forEach(element => {
        element.isSelected = false;
      });

      if(Object.keys(this.endorsementUnderwritingForm.EndorsementForm).length == 0){
        this.endorsementUnderwritingForm.selectedStep = EndorsementSteps.BasicInfo;
        this.endorsementService.selectedStep = EndorsementSteps.BasicInfo;
      }

      this.endorsementService.endorsement = this.endorsementUnderwritingForm;
      this.modalReference.close();
    }
  }

  openRemoveRequestModal(_type, _label) {
    this.modalReference = this.modalService.open(this.removeRequestModal, { centered: false, backdropClass: 'light-blue-backdrop' });
    this.removeRequestLabel = _label;
    this.removeRequestType = _type;
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
   }

  onContinue():boolean{
    //this.endorsementUnderwritingForm.supportingDocuments = this.endorsementService.getSupportingDocuments();
    this.isSubmitted = true;
    event.preventDefault();

    this.acordAttachmentError = (this.endorsementUnderwritingForm.isAcordForm && (!this.supportingDocuments || this.supportingDocuments.length==0)) ? this.endorsementMsgs.DocumentRequired : null;

    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
    }
    return (this.underwritingForm.valid && !this.acordAttachmentError);
  }
}
